export const LOAD_MANUAL_CATEGORIES = 'LOAD_MANUAL_CATEGORIES'
export const LOAD_MANUAL_CATEGORIES_ERROR = 'LOAD_MANUAL_CATEGORIES_ERROR'
export const LOAD_MANUAL_CATEGORIES_SUCCESS = 'LOAD_MANUAL_CATEGORIES_SUCCESS'

export const SELECT_MANUAL_CATEGORY = 'SELECT_MANUAL_CATEGORY'
export const DESELECT_MANUAL_CATEGORY = 'DESELECT_MANUAL_CATEGORY'

export const SAVE_MANUAL_CATEGORY = 'SAVE_MANUAL_CATEGORY'
export const SAVE_MANUAL_CATEGORY_SUCCESS = 'SAVE_MANUAL_CATEGORY_SUCCESS'
export const SAVE_MANUAL_CATEGORY_ERROR = 'SAVE_MANUAL_CATEGORY_ERROR'

export const CREATE_MANUAL_CATEGORY = 'CREATE_MANUAL_CATEGORY'
export const CREATE_MANUAL_CATEGORY_ERROR = 'CREATE_MANUAL_CATEGORY_ERROR'
export const CREATE_MANUAL_CATEGORY_SUCCESS = 'CREATE_MANUAL_CATEGORY_SUCCESS'

export const UPDATE_MANUAL_CATEGORY = 'UPDATE_MANUAL_CATEGORY'
export const UPDATE_MANUAL_CATEGORY_ERROR = 'UPDATE_MANUAL_CATEGORY_ERROR'
export const UPDATE_MANUAL_CATEGORY_SUCCESS = 'UPDATE_MANUAL_CATEGORY_SUCCESS'

export const DELETE_MANUAL_CATEGORY = 'DELETE_MANUAL_CATEGORY'
export const DELETE_MANUAL_CATEGORY_ERROR = 'DELETE_MANUAL_CATEGORY_ERROR'
export const DELETE_MANUAL_CATEGORY_SUCCESS = 'DELETE_MANUAL_CATEGORY_SUCCESS'

export const LOAD_MANUAL_LIST = 'LOAD_MANUAL_LIST'
export const LOAD_MANUAL_LIST_ERROR = 'LOAD_MANUAL_LIST_ERROR'
export const LOAD_MANUAL_LIST_SUCCESS = 'LOAD_MANUAL_LIST_SUCCESS'

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT'

export const SEARCH_MANUAL_LIST = 'SEARCH_MANUAL_LIST'
export const SEARCH_MANUAL_LIST_ERROR = 'SEARCH_MANUAL_LIST_ERROR'
export const SEARCH_MANUAL_LIST_SUCCESS = 'SEARCH_MANUAL_LIST_SUCCESS'
export const SEARCH_MANUAL_LIST_RESET = 'SEARCH_MANUAL_LIST_RESET'

export const SELECT_MANUAL = 'SELECT_MANUAL'
export const DESELECT_MANUAL = 'DESELECT_MANUAL'

export const CREATE_MANUAL = 'CREATE_MANUAL'
export const CREATE_MANUAL_ERROR = 'CREATE_MANUAL_ERROR'
export const CREATE_MANUAL_SUCCESS = 'CREATE_MANUAL_SUCCESS'

export const UPDATE_MANUAL = 'UPDATE_MANUAL'
export const UPDATE_MANUAL_ERROR = 'UPDATE_MANUAL_ERROR'
export const UPDATE_MANUAL_SUCCESS = 'UPDATE_MANUAL_SUCCESS'

export const UPLOAD_MANUAL_FILE = 'UPLOAD_MANUAL_FILE'
export const UPLOAD_MANUAL_FILE_ERROR = 'UPLOAD_MANUAL_FILE_ERROR'
export const UPLOAD_MANUAL_FILE_SUCCESS = 'UPLOAD_MANUAL_FILE_SUCCESS'

export const SAVE_MANUAL = 'SAVE_MANUAL'
export const SAVE_MANUAL_ERROR = 'SAVE_MANUAL_ERROR'
export const SAVE_MANUAL_SUCCESS = 'SAVE_MANUAL_SUCCESS'

export const DELETE_MANUAL = 'DELETE_MANUAL'
export const DELETE_MANUAL_ERROR = 'DELETE_MANUAL_ERROR'
export const DELETE_MANUAL_SUCCESS = 'DELETE_MANUAL_SUCCESS'
